// extracted by mini-css-extract-plugin
export default {"card":"jZ-z","carouselContainer":"kZ-z","carouselContent":"lZ-z"};